import React, { useState } from "react";
import { Nav } from "react-bootstrap";

import {
  MdRestaurantMenu,
  MdPerson,
  MdDashboard,
  MdPieChart,
  MdShowChart,
  MdPersonAdd,
  MdDiscount,
  MdCampaign,
  MdAccountBalance,
  MdMail,
  MdStar,
  MdSettings,
  MdKeyboardArrowDown,
  MdMenu,
  MdKeyboardArrowRight
} from 'react-icons/md'

export default function SideNav() {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true)

  const handleExpand = () => setIsExpanded(!isExpanded);
  const handleSidebarToggle = () => {
    setIsSidebarExpanded(!isSidebarExpanded);
    setIsExpanded(!isExpanded)
  }
  return (
    <nav className={`navbar-static-side ${isSidebarExpanded ? '' : "sidebar-collapsed"}`}>
      <div className="sidebar-collapse">
        <div className="nav-header">
          <span className={"logo-name " + (isSidebarExpanded ? "" : "hidden")}>Feasti</span>
          <span className="nav-toggler" onClick={handleSidebarToggle}>
            <MdMenu size={24} color="#FFFFFF" />
          </span>
        </div>
        <div className="sidebar-body">
          <Nav id="side-menu">
            <Nav.Link href="/" className="nav-label">
              <MdDashboard size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                Dashboard
              </span>
            </Nav.Link>
            <Nav.Link href="/users" className="nav-label">
              <MdPerson size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                Users
              </span>
            </Nav.Link>

            <Nav.Item>
              <Nav.Link
                className="nav-label"
                aria-expanded={isExpanded}
                onClick={handleExpand}>
                <div className="d-flex align-items-center">
                  <MdRestaurantMenu size={18} />
                  <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                    Restaurant
                  </span>
                </div>
                <div className={isSidebarExpanded ? "" : "d-none"}>
                  {isExpanded ? (
                    <MdKeyboardArrowDown size={18} />
                  ) : (
                    <MdKeyboardArrowRight size={18} />
                  )}
                </div>

              </Nav.Link>
              <div className="nav-second-level" aria-hidden={!isExpanded}>
                <Nav.Link href="/restaurant" className="nav-label">
                  <MdShowChart size={18} />
                  <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                    Dashboard
                  </span>
                </Nav.Link>
                <Nav.Link href="/add_restaurant" className="nav-label">
                  <MdPersonAdd size={18} />
                  <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                    Add New Restaurant
                  </span>
                </Nav.Link>
              </div>
            </Nav.Item>

            <Nav.Link href="/orders" className="nav-label">
              <MdPieChart size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                Orders
              </span>
            </Nav.Link>
            <Nav.Link href="/coupons" className="nav-label">
              <MdDiscount size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                Coupons
              </span>
            </Nav.Link>
            <Nav.Link href="/campaign" className="nav-label">
              <MdCampaign size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>
                Campaigns
              </span>
            </Nav.Link>

            <Nav.Link href="/payments" className=" nav-label">
              <MdAccountBalance size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>Payments</span>
            </Nav.Link>
            {/* Payments */}

            <Nav.Link href="/contacts" className=" nav-label">
              <MdMail size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>Contacts and Supports</span>
            </Nav.Link>
            {/* Support */}

            <Nav.Link href="/review" className=" nav-label">
              <MdStar size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>Reviews</span>
            </Nav.Link>
            {/* Support */}

            <Nav.Link href="/setting" className=" nav-label">
              <MdSettings size={18} />
              <span className={isSidebarExpanded ? 'links-name-side' : 'sr-only'}>Setting</span>
            </Nav.Link>
            {/* Settings */}

          </Nav>
        </div>
      </div>
    </nav>
  );
}
